import router from '@/router'
import { ElMessage } from 'element-plus'

let redirecting = false

export function isUnauthorizedResponse(response) {
  if (!response) return false
  if (response.status === 401) return true
  const code = response.data?.code
  return code == 401
}

export function handleUnauthorized(msg) {
  if (redirecting) return
  redirecting = true

  localStorage.clear()

  if (msg) {
    ElMessage.error(msg)
  } else {
    ElMessage.error('登录已过期，请重新登录')
  }

  if (router.currentRoute.value.path !== '/') {
    router.replace('/')
  }

  setTimeout(() => {
    redirecting = false
  }, 1000)
}
